
import Vue from "vue";
import { TrashIcon, PlusIcon, ChevronDownIcon, ChevronUpIcon, XIcon, PaperclipIcon } from 'vue-feather-icons';
import TipTap from "../../commons/RomaTipTap.vue";

export default Vue.extend({
    name: "RomaActivityPieForm",
    components: {
        TrashIcon,
        PlusIcon,
        ChevronDownIcon,
        ChevronUpIcon,
        XIcon,
        PaperclipIcon,
        TipTap
    },
    props: {
        value: {
            type: Object,
            required: true
        },
        unitOAs: {
            type: Array,
            default: () => []
        },
        duas: {
            type: Array,
            default: () => []
        },
        evaluationTypes: {
            type: Array,
            default: () => []
        },
        instrumentTypes: {
            type: Array,
            default: () => []
        },
        activityType: {
            type: [String, Number],
            default: 1
        }
    },
    data() {
        return {
            tab: 0,
            selectIEMode: true
        };
    },
    computed: {
        computedUnitOAs() {
            const selectedIEIds = this.value.selectedIEs.map((ie: any) => ie.id);
            if (!this.selectIEMode) {
                return this.unitOAs.map((oa: any) => {
                    return {
                        ...oa,
                        ies: oa.ies.filter((ie: any) => selectedIEIds.includes(ie.id))
                    }
                }).filter((oa: any) => oa.ies.length > 0);
            }
            return this.unitOAs;
        }
    },
    mounted() {
        if (this.value.selectedIEs && this.value.selectedIEs.length > 0) {
            this.selectIEMode = false;
        }
    },
    methods: {
        isOaSelected(oaId: number) {
            return this.value.selectedIEs.some((ie: any) => ie.oa_id === oaId);
        },
        toggleOa(oa: any) {
            const isSelected = this.isOaSelected(oa.id);
            if (isSelected) {
                this.value.selectedIEs = this.value.selectedIEs.filter((ie: any) => ie.oa_id !== oa.id);
            } else {
                // Add all IEs of this OA
                const newIEs = oa.ies.filter((ie: any) => !this.value.selectedIEs.some((selected: any) => selected.id === ie.id));
                this.value.selectedIEs = [...this.value.selectedIEs, ...newIEs];
            }
        },
        isIeSelected(ie: any) {
            return this.value.selectedIEs.some((selected: any) => selected.id === ie.id);
        },
        toggleIe(ie: any) {
            const index = this.value.selectedIEs.findIndex((selected: any) => selected.id === ie.id);
            if (index > -1) {
                this.value.selectedIEs.splice(index, 1);
            } else {
                this.value.selectedIEs.push(ie);
            }
        },
        removeDua(index: number) {
            this.value.selectedDuas.splice(index, 1);
        },
        addMoment() {
            this.value.momentos.push({
                titulo: 'Nuevo Momento',
                actividadMomento: '',
                files: [],
                evaluaciones: []
            });
            this.tab = this.value.momentos.length - 1;
        },
        removeMoment() {
            if (this.value.momentos.length > 0) {
                this.value.momentos.pop();
                if (this.tab >= this.value.momentos.length) {
                    this.tab = Math.max(0, this.value.momentos.length - 1);
                }
            }
        },
        uploadMomentFile(index: number) {
            const input = document.getElementById('file-input-pie-moment-' + index);
            if (input) input.click();
        },
        onMomentFileChange(event: any, moment: any) {
            const files = Array.from(event.target.files);
            moment.files = [...moment.files, ...files];
        },
        removeMomentFile(moment: any, index: number) {
            moment.files.splice(index, 1);
        },
        downloadFile(file: any) {
            this.$emit('download-file', file);
        },
        addEvaluation(moment: any) {
            if (!moment.evaluaciones) {
                this.$set(moment, 'evaluaciones', []);
            }
            moment.evaluaciones.push({
                actividadEvaluacion: '',
                idTipoEvaluacion: null,
                idTipoInstrumentoEvaluacion: null,
                files: []
            });
        },
        uploadEvaluationFile(momentIndex: number, evaluationIndex: number) {
            const input = document.getElementById('file-input-pie-evaluation-' + momentIndex + '-' + evaluationIndex);
            if (input) input.click();
        },
        onEvaluationFileChange(event: any, evaluation: any) {
            const files = Array.from(event.target.files);
            evaluation.files = [...evaluation.files, ...files];
        },
        removeEvaluationFile(evaluation: any, index: number) {
            evaluation.files.splice(index, 1);
        }
    }
});
